<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Data Imports</div>
		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="requestRepollDisplay = true">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'calendar-arrow-up']" size="lg" class="ms-1 me-2"></fa-icon>
						Repoll
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="dataImportFiles"
		[loading]="!dataImportFiles"
		[globalFilterFields]="app.keys(dataImportFiles)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						Check Date
						<p-sortIcon field="checkDate"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="checkDate" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						Last Size
						<p-sortIcon field="sizeReadable"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="sizeReadable" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						Last Imported
						<p-sortIcon field="presentedDateTime"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="Date" field="presentedDateTime" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td>
					{{ app.moment(rec.checkDate, "MMDDYYYY").format("L") }}
				</td>
				<td>{{ rec.sizeReadable }}</td>
				<td>
					<div class="d-flex w-100">
						{{ app.moment(rec.presentedDateTime).format("L LT") }}
						<div class="ms-auto">
							<app-record-control-footer
								[hideAdd]="true"
								[hideCancel]="true"
								[hideDelete]="false"
								[hideSave]="true"
								(onDeleteChange)="dataImportFileDeleteOne(rec.fileName)"
								[deleteDisabled]=""
							></app-record-control-footer>
						</div>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-dialog [(visible)]="requestRepollDisplay" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'calendar-arrow-up']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">Request API Repoll</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<ng-template pTemplate="content">
		<div class="d-flex w-100 justify-content-center mx-auto">
			<p-calendar [(ngModel)]="requestRepollDate" [inline]="true"></p-calendar>
		</div>
	</ng-template>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="requestRepollDisplay = false"
			(onSaveChange)="requestRepoll()"
			[cancelDisabled]=""
			[saveDisabled]="!requestRepollDate"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
